import React, {PureComponent} from "react";
import Avatar from "housecall-ui/dist/DesignSystem/DataDisplay/Avatar/Avatar"
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import Typography from "housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography"
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'

const styles = theme => ({
    button: {
        width: '100%',
        textTransform: 'none'
    },
});
@withStyles(styles)
export default class CreateUpdateServicePro extends PureComponent {
    render() {
        const {classes, servicePro} = this.props;
        return (
            <Grid item style={{width: '100%'}}>
                <Button className={classes.button}
                        size={'small'}
                        onClick={() => {
                            this.props.onServiceProSelected(servicePro)
                        }}>
                    <Grid container justify='flex-start' alignItems='center' wrap='nowrap' spacing={8}>
                        <Grid item>
                            <Avatar alt="Employee" src={servicePro.avatar_url}/>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle1">{servicePro.full_name}</Typography>
                        </Grid>
                    </Grid>
                </Button>
            </Grid>)
    }
}
